'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./~/intl-format-cache/index.js
// module id = 1311
// module chunks = 82